import type { IPostVMProps } from '@data/view-models';

import type { IChapterProps } from './interface';

export function postTitle({ title, seriesPost }: IPostVMProps): string {
  const { nextPart, previousPart, chapterTitle, series } = seriesPost || {};

  if ((!!nextPart || !!previousPart) && series?.title) {
    return `${series?.title}: ${chapterTitle}`;
  }

  return title;
}

export function nextChapterInfo({
  seriesPost,
}: IPostVMProps): IChapterProps | null {
  const { nextPart } = seriesPost || {};

  if (!nextPart) {
    return null;
  }

  const { slug, seriesPost: nextSeriesPost } = nextPart;
  const { chapter = 0, chapterSlug } = nextSeriesPost || {};

  return {
    chapter,
    slug: chapterSlug || slug,
    title: postTitle(nextPart),
  };
}

export function previousChapterInfo({
  seriesPost,
}: IPostVMProps): IChapterProps | null {
  const { previousPart } = seriesPost || {};

  if (!previousPart) {
    return null;
  }

  const { slug, seriesPost: nextSeriesPost } = previousPart;
  const { chapter = 0, chapterSlug } = nextSeriesPost || {};

  return {
    chapter,
    slug: chapterSlug || slug,
    title: postTitle(previousPart),
  };
}
